import React from 'react';
import { logoutOfWeb3Modal } from '../utils/web3Modal';
import { MetaMaskButton } from 'rimble-ui';
import ReactGa from 'react-ga';

export default function WalletButton({ provider, loadWeb3Modal }) {
	const ButtonHandler = () => {
		if (!provider) {
			// Sign in
			loadWeb3Modal();
			ReactGa.event({
				category: 'Button',
				action: 'Sign in with Metamask'
			});
		} else {
			// Signout
			logoutOfWeb3Modal();
			ReactGa.event({
				category: 'Button',
				action: 'Sign out with Metamask'
			});
		}
	};

	return (
		<MetaMaskButton.Outline
			style={{
				borderRadius: '16px',
				margin: '30px 30px 0px 0px',
				display: 'inherit'
			}}
			onClick={ButtonHandler}
		>
			{' '}
			{!provider ? 'Connect Wallet' : 'Disconnect Wallet'}
		</MetaMaskButton.Outline>
	);
}
